import tonStyles from './../ton.json'

export default {
  name: '4',
  color: tonStyles.colors.PrimaryBlack,
  inverseColor: tonStyles.colors.PrimaryWhite
}
